import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {};
const translations = require.context('../translations', true, /.json$/);

// populate the resources object with the translations
translations.keys().forEach(path => {
  // this generates an array like:
  // ['.', 'en', 'file.json']
  const keys = path.split('/');

  const language = keys[1];

  // gets fileName and removes .json from it
  const namespace = keys[2].split('.')[0];

  // add language property if it doesnt exist
  if (!resources[language]) {
    resources[language] = {};
  }

  // add translations to resources object
  resources[language][namespace] = translations(path);
});

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
